var CardEndpoints;
(function (CardEndpoints) {
    CardEndpoints["ActivateCard"] = "/cards/activate-card";
    CardEndpoints["ActivateCardLoggedIn"] = "/cards/activate-card-logged-in";
    CardEndpoints["CreatePaymentAuthCode"] = "/cards/create-payment-auth-code";
    CardEndpoints["CreateViewCardToken"] = "/cards/create-view-card-token";
    CardEndpoints["CreateViewCardTokenV2"] = "/cards/v2/create-view-card-token";
    CardEndpoints["ChangeCardPin"] = "/cards/change-card-pin";
    CardEndpoints["GetCardSummaries"] = "/cards/get-card-summaries";
    CardEndpoints["GetCardSummariesV2"] = "/cards/v2/get-card-summaries";
    CardEndpoints["GetPushProvisioningData"] = "/cards/get-push-provisioning-data";
    CardEndpoints["ReplaceCard"] = "/cards/replace-card";
    CardEndpoints["UpdateCardStatus"] = "/cards/update-card-status";
})(CardEndpoints || (CardEndpoints = {}));
/**
 * The various states that a card can be in.
 */
var CardStatus;
(function (CardStatus) {
    CardStatus["Unspecified"] = "CARD_STATUS_UNSPECIFIED";
    /**
     * Card actively being used.
     * Virtual cards are initialized in this state.
     */
    CardStatus["Active"] = "ACTIVE";
    /**
     * Card has been permanently closed.
     * It can no longer be used to make transactions.
     * Cards can be closed for a variety of reasons, detailed in CardStatusReason, as well as if they expire.
     */
    CardStatus["Closed"] = "CLOSED";
    /**
     * Card activity is frozen, and can be unfrozen at any time.
     * It can not currently be used to make transactions.
     * Users can initiate a card freeze if they think that their card has been stolen or otherwise compromised.
     * We can initiate a card freeze internally in the event of suspected fraud.
     */
    CardStatus["Frozen"] = "FROZEN";
    /**
     * Relevant to physical cards only: card is not yet requested for embossing.
     *
     */
    CardStatus["OnHold"] = "ON_HOLD";
    /**
     * This is a new card that has not yet been activated.
     * Physical cards are initialized in this state.
     */
    CardStatus["PendingActivation"] = "PENDING_ACTIVATION";
})(CardStatus || (CardStatus = {}));
/**
 * Author of most recent card status.
 */
var CardStatusAuthor;
(function (CardStatusAuthor) {
    CardStatusAuthor["Unspecified"] = "CARD_STATUS_AUTHOR_UNSPECIFIED";
    /** User updated card status */
    CardStatusAuthor["User"] = "USER";
    /** Customer support agent updated card status */
    CardStatusAuthor["CustomerSupport"] = "CUSTOMER_SUPPORT";
    /** Automated job for pre-activation and disabling due to inactivity */
    CardStatusAuthor["Automated"] = "AUTOMATED";
})(CardStatusAuthor || (CardStatusAuthor = {}));
/**
 * Reason for card status change
 * If none of the defined reasons apply, use OTHER
 */
var CardStatusReason;
(function (CardStatusReason) {
    CardStatusReason["Unspecified"] = "CARD_STATUS_REASON_UNSPECIFIED";
    /** Physical card was lost */
    CardStatusReason["Lost"] = "LOST";
    /** Physical/virtual card was stolen */
    CardStatusReason["Stolen"] = "STOLEN";
    /**
     * Physical card was damaged.
     * If a replacement is requested for a damaged card, the replacement will have the same information as the original.
     * i.e. the replacement card will have same card number, uuid, cvv, etc.
     */
    CardStatusReason["Damaged"] = "DAMAGED";
    /**
     * None of the other categories apply.
     * Or, the user has not specified a reason for the status change.
     */
    CardStatusReason["Other"] = "OTHER";
    /**
     * If the card is inactive (both unused and not activated) for a certain period after pre-activation,
     * the status is set back through an automated job to PENDING_ACTIVATION with reason INACTIVITY
     */
    CardStatusReason["Inactivity"] = "INACTIVITY";
    /**
     * When the account is created with the holdEmbossing flag set to 1, the card is
     * created with the status "Hold embossing", meaning it will not automatically
     * trigger embossing.
     * To initiate embossing, you must call the CardReplacement API with the reason
     * set to FIRST_CARD. This will change the status from "Hold embossing" to
     * "Requested to be embossed".
     */
    CardStatusReason["FirstCard"] = "FIRST_CARD";
    /**
     * When Unified Card Number is enabled, card replacement is done on the physical card
     * So if we are replacing the cards because virtual card needs to be replaced, we set the reason to VIRTUAL_CARD_REPLACEMENT
     */
    CardStatusReason["VirtualCardReplacement"] = "VIRTUAL_CARD_REPLACEMENT";
    /**
     * Admin-only: issues a new physical card for an account whose original physical card was closed
     * without a replacement. Rejected unless the card being replaced is PHYSICAL and CLOSED.
     */
    CardStatusReason["PhysicalCardReplacement"] = "PHYSICAL_CARD_REPLACEMENT";
})(CardStatusReason || (CardStatusReason = {}));
/**
 * Physical or virtual card.
 */
var CardType;
(function (CardType) {
    CardType["Unspecified"] = "CARD_TYPE_UNSPECIFIED";
    CardType["Physical"] = "PHYSICAL";
    CardType["Virtual"] = "VIRTUAL";
})(CardType || (CardType = {}));
var ShippingSpeed;
(function (ShippingSpeed) {
    ShippingSpeed["Unspecified"] = "SHIPPING_SPEED_UNSPECIFIED";
    ShippingSpeed["Standard"] = "STANDARD";
    ShippingSpeed["Priority"] = "PRIORITY";
    ShippingSpeed["Overnight"] = "OVERNIGHT";
})(ShippingSpeed || (ShippingSpeed = {}));
var PaymentTokenPurpose;
(function (PaymentTokenPurpose) {
    PaymentTokenPurpose["PAYMENT_TOKEN_PURPOSE_UNSPECIFIED"] = "PAYMENT_TOKEN_PURPOSE_UNSPECIFIED";
    PaymentTokenPurpose["CHECKOUT"] = "CHECKOUT";
})(PaymentTokenPurpose || (PaymentTokenPurpose = {}));
var CardsError;
(function (CardsError) {
    /**
     * No cards found in the "PENDING_ACTIVATION" state.
     * "Your card is already activated."
     */
    CardsError["NO_CARDS_PENDING_ACTIVATION"] = "NO_CARDS_PENDING_ACTIVATION";
    /** "You are attempting to save a card that already exists." */
    CardsError["CARD_ALREADY_EXISTS"] = "CARD_ALREADY_EXISTS";
    /**
     * There are multiple actions that cannot be performed if a card hasn't been activated yet.
     * e.g. freeze/unfreeze card, view card number & cvv, etc.
     * "Your card is not yet activated. Cannot perform action."
     *
     */
    CardsError["CARD_PENDING_ACTIVATION"] = "CARD_PENDING_ACTIVATION";
    /**
     *  Card hasn't been delivered yet, so certain actions shouldn't be possible.
     * e.g. activate card
     * "Your card has not yet been delivered. Cannot perform action."
     */
    CardsError["CARD_PENDING_DELIVERY"] = "CARD_PENDING_DELIVERY";
})(CardsError || (CardsError = {}));
export { CardEndpoints, CardStatus, CardStatusAuthor, CardStatusReason, CardType, CardsError, PaymentTokenPurpose, ShippingSpeed, };
